import React from 'react';
import PropTypes from 'prop-types';
import { fetchClasses } from '../services/options_services';
import InputAsyncInformed from './InputAsyncInformed';

const ClassInputAsync = ({ params, ...props }) => (
  <InputAsyncInformed
    defaultOptions
    placeholder="Turma"
    loadOptions={(search) => fetchClasses({ search, ...params })}
    {...props}
  />
);

ClassInputAsync.propTypes = {
  params: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.object])
  ),
};

ClassInputAsync.defaultProps = {
  params: {},
};

export default ClassInputAsync;
